import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isSendingSelector } from '../selectors/authSelectors';
import { checkUsernameRequest } from '../actions/authActions';
import UsernameForm from '../components/UsernameForm/UsernameForm';

const mapStateToProps = createStructuredSelector({ isSending: isSendingSelector });
const mapDispatchToProps = { checkUsernameRequest };

export default connect(mapStateToProps, mapDispatchToProps)(UsernameForm);
